/** @file Compiled store: the identity compile of the viewed document as SkeletonData (spec §9 `compiled`). */
import type { SkeletonData } from '@pose2d/core/types';
import type { AtlasJson, Doc, Pose2DJson, Warning } from '@pose2d/format/types';
import { createStore } from 'zustand/vanilla';

/** `data` is the last document that compiled; `error` is the newest compile failure (null once one compiles). */
export interface CompiledState {
  doc: Doc | null;
  json: Pose2DJson | null;
  atlas: AtlasJson | null;
  data: SkeletonData | null;
  warnings: Warning[];
  error: unknown;
}

/** Written only by syncCompiled; the viewport reads it outside React, panels through useStore. */
export const compiledStore = createStore<CompiledState>()(() => ({ doc: null, json: null, atlas: null, data: null, warnings: [], error: null }));
